import { render, staticRenderFns } from "./UserProfile.vue?vue&type=template&id=615e868d"
import script from "./UserProfile.vue?vue&type=script&lang=js"
export * from "./UserProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('615e868d')) {
      api.createRecord('615e868d', component.options)
    } else {
      api.reload('615e868d', component.options)
    }
    module.hot.accept("./UserProfile.vue?vue&type=template&id=615e868d", function () {
      api.rerender('615e868d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/wizard/UserProfile.vue"
export default component.exports